import { Component, OnInit } from '@angular/core';
import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { FormBuilder, Validators } from '@angular/forms';
import { UsuariosService } from 'src/app/services/usuarios/usuarios.service';
import { IBusquedaUsuarios, IListaBusquedaUsuarios, IUsuarios } from 'src/app/interfaces/usuarios';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-view-mantenedor-usuario-crear',
  templateUrl: './view-mantenedor-usuario-crear.component.html',
  styleUrls: ['./view-mantenedor-usuario-crear.component.scss']
})
export class ViewMantenedorUsuarioCrearComponent implements OnInit {
  dtOptions: DataTables.Settings = {}
  renderTable: boolean = true
  listaUsuarios: Array<IBusquedaUsuarios> = []
  formularioBusqueda = this.formBuilder.group({
    texto: ['', [Validators.required, Validators.minLength(4)]],
  })
  usuarios: Array<IUsuarios> = []
  infoModalTitulo: string = ''
  infoModalTexto: string = ''
  alertErrorTxt: string = ''

  get textoBusqueda() { return this.formularioBusqueda.get('texto')?.value; }

  constructor(
    private formBuilder: FormBuilder,
    private usuarioService: UsuariosService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {
    // this.getUsuarios()
  }

  buscarUsuario() {
    this.renderTable = false
    const textoBusqueda: string = this.formularioBusqueda.value.texto ? this.formularioBusqueda.value.texto : ''
    this.usuarioService.buscarUsuarios(textoBusqueda).subscribe(
      (res: IListaBusquedaUsuarios) => {
        if ( res.error === null ) {
          this.listaUsuarios = res.usuarios
        } else {
          this.alertErrorTxt = res?.error?.mensaje ?? 'Usuario no encontrado'
          setTimeout(() => {
            this.alertErrorTxt = ''
          }, 3000);
        }
        this.renderTable = true
      }, err => {
        this.listaUsuarios = [];
        this.renderTable = true
      }
    )
  }

  showInfoModal(titulo: string = '', texto: string = '') {
    this.infoModalTitulo = titulo
    this.infoModalTexto = texto
    document.getElementById('btn-modal-info')?.click()
  }

  seleccionarRolSedeUsuario(usuario: IBusquedaUsuarios) {
    this.spinner.show()
    this.usuarioService.getUsuarios(usuario.username).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.usuarios = res.listado
        const usuarioExiste = this.usuarios.filter((user: IUsuarios) => user.username.toUpperCase() === usuario.username.toUpperCase() )
        if ( usuarioExiste.length === 0 ) {
          this.router.navigate(['/usuario-crear-seleccionar'], { state: { data: { infoUsuario: usuario } } })
        } else {
          this.showInfoModal('Atención', `El usuario ${usuario.username} ya se encuentra en estado vigente`)
        }
      }
    )
  }

  ngOnInit(): void {
    this.dtOptions = { ...DatatableConfig.simpledt }
  }
}
